import React, { useState } from 'react';
import BsModal from '../Common/BsModal';
import { useConfig } from '../../DataStore/ConfigContext';
import Notification from '../Common/Notification';
import ajaxVoucher from '../../util/remote/ajaxVoucher';
import { useAuth } from '../../DataStore/AuthContext';


const AgentFloatModal = ({ show, onClose, onSuccess, selectedAgent, modalType }) => {
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  const {connectedProfiles} = useAuth();
  const [amount, setAmount] = useState('');
  const[description, setDescription] = useState('');

  const money = (v) =>  connectedProfiles?.currency + ' ' + new Intl.NumberFormat('en-UG').format(v);
  
  const handleSubmit = async () => {
    if (loading) return;
    if (amount <= 0 || isNaN(amount)) {
      setNotify(<Notification type="danger" message="Please enter a valid amount." />);
      return;
    }
    
    const data={
        user_id: selectedAgent.id,
        amount: amount,
        description: description.length > 0 ? description : null,
    }

    setLoading(true);
    const server_response = modalType === "withdraw" ? await ajaxVoucher.withdrawFloat(data) : await ajaxVoucher.depositFloat(data);
    setLoading(false);
    if (server_response.status === 'OK') {
      setNotify(<Notification type="success" message={server_response.message} />);
      setTimeout(
        () => {
            onSuccess();
            setAmount('');
            setDescription('');
            setNotify(null);
        }, 1000);
    } else {
      setNotify(<Notification type="danger" message={server_response.message} />);
    }
  };

  const title = modalType === "withdraw" ? "Withdraw" : "Deposit"


  return (
    <BsModal
      show={show}
      onClose={onClose}
      title={modalType === "withdraw" ? "Withdraw Float" : "Deposit Float"}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button 
            type="button" 
            className={modalType === "withdraw" ? "btn btn-danger" : "btn btn-primary"}
            onClick={handleSubmit}>
            <i className="fa fa-check-circle mr-1" />
            {loading ? ' Processing...' : ` ${title} Float`}
          </button>
        </>
      }
    >
      {notify}

              <div className="mb-2">
                <div className="small text-muted">Agent</div>
                <div className="font-weight-bold">
                  {selectedAgent ? `${selectedAgent.name} • ${selectedAgent.phone}` : "—"}
                </div>
              </div>

              <div className="alert alert-light border small">
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Current Float</span>
                  <span className="font-weight-bold">
                    {selectedAgent ? money(selectedAgent.floatUGX) : "—"}
                  </span>
                </div>
              </div>

              <div className="form-group">
                <label className="small font-weight-bold">Amount ({connectedProfiles?.currency})</label>
                <input type="number" className="form-control" placeholder="e.g. 50000" value={amount} onChange={e => setAmount(e.target.value)} />
              </div>

              <div className="form-group">
                <label className="small font-weight-bold">Reference / Note</label>
                <input type="text" className="form-control" placeholder="Optional note or reference…" value={description} onChange={e => setDescription(e.target.value)} />
              </div>


              <div className="small text-muted">
                This action will be recorded in the agent float ledger for audit.
              </div>

      
    </BsModal>
  );
};

export default AgentFloatModal;
